/* eslint-disable @typescript-eslint/no-explicit-any */
export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}

export type HttpRequestConfig = Partial<{
  headers: Record<string, string>;
  params: unknown;
  data: unknown;
  adapter: 'fetch';
  fetchOptions: { keepalive?: boolean };
}>;

export interface HttpClient {
  onUnauthorized(listener: (reason: unknown) => void): void;

  get<ResponseData = any, ResponseMeta = any>(
    url: string,
    config?: HttpRequestConfig,
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }>;

  post<ResponseData = any, ResponseMeta = any>(
    url: string,
    config?: HttpRequestConfig,
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }>;

  put<ResponseData = any, ResponseMeta = any>(
    url: string,
    config?: HttpRequestConfig,
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }>;
}
